import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrganisationAdditionalChargeTypeComponent } from './organisation-additional-charge-type.component';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from 'src/app/vme-common.module';
import { VmeDirectivesModule } from 'src/app/vme-directives.module';
import { VmePipesModule } from 'src/app/vme-pipes.module';
import { VMEComponentsModule } from 'src/app/vme-components.module';
import { TableModule } from 'primeng/table';

const routes: Routes = [
  {
    path: '',
    component: OrganisationAdditionalChargeTypeComponent,
    data: { title: 'Organisation Additional Charges Type' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrganisationAdditionalChargeTypeRoutingModule {}

@NgModule({
  imports: [
    OrganisationAdditionalChargeTypeRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    TableModule,
  ],
  declarations: [OrganisationAdditionalChargeTypeComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [OrganisationAdditionalChargeTypeComponent],
})
export class OrganisationAdditionalChargeTypeModule {}
